/* eslint-disable */
import {Service} from 'components/Shared/server';
import {RentalPeriod} from 'models/RentalPeriod';
import {AddItemRequest} from 'models/AddItemRequest';
import {AddSampleItemRequest} from 'models/AddSampleItemRequest';
import {CartResponse} from 'models/CartResponse';
import {AddItemResponse} from 'models/AddItemResponse';

type UpdateItemRequest = {id: string; parentId: string | null; quantity: number; rentalPeriod: RentalPeriod;};

export const routeGetIndex = (includeLowestPartPaymentCost: boolean, filterExpiredProducts?: boolean) => `/api/cart?includeLowestPartPaymentCost=${includeLowestPartPaymentCost}&filterExpiredProducts=${filterExpiredProducts}`;
export function getIndex(includeLowestPartPaymentCost: boolean, filterExpiredProducts?: boolean): Promise<CartResponse> {
  return Service.get<CartResponse>({
    url: routeGetIndex(includeLowestPartPaymentCost, filterExpiredProducts)
  });
}

export const routePostAddToCart = () => `/api/cart/add`;
export function postAddToCart(input: AddItemRequest): Promise<AddItemResponse> {
  return Service.post<AddItemResponse>({
    url: routePostAddToCart(),
    body: input
  });
}

export const routePostAddSampleToCart = () => `/api/cart/addsample`;
export function postAddSampleToCart(input: AddSampleItemRequest): Promise<AddItemResponse> {
  return Service.post<AddItemResponse>({
    url: routePostAddSampleToCart(),
    body: input
  });
}

export const routePostAddItems = () => `/api/cart/add/items`;
export function postAddItems(input: AddItemRequest[]): Promise<AddItemResponse> {
  return Service.post<AddItemResponse>({
    url: routePostAddItems(),
    body: input
  });
}

export const routePostUpdateItem = () => `/api/cart/item`;
export function postUpdateItem(input: UpdateItemRequest): Promise<CartResponse> {
  return Service.post<CartResponse>({
    url: routePostUpdateItem(),
    body: input
  });
}

export const routeDeleteRemove = (id: string) => `/api/cart/remove/${encodeURIComponent(id)}`;
export function deleteRemove(id: string): Promise<CartResponse> {
  return Service.remove<CartResponse>({
    url: routeDeleteRemove(id)
  });
}
